<template>
  <div>
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        :style="{height: `${height}px`, 'overflow-y': 'hidden'}"
        v-model="richText"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
        @onBlur="onBlur"
        @onChange="onChange"
      />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { max } from "moment";
export default {
  name: "",
  components: { Editor, Toolbar },
  model: {
    prop: "html",
    event: "update",
  },
  props: {
    html: String,
    readOnly: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 5000,
    },
    height: {
      type: Number,
      default: 300,
    },
    toolbarConfig: {
      default: () => ({
        toolbarKeys: ["bold", "color"]
      }),
    }
  },
  data() {
    return {
      editor: null,
      // toolbarConfig: {
      //   toolbarKeys: ["bold", "color"],
      // },
      editorConfig: {
        placeholder: "请输入内容...",
        maxLength: this.maxLength,
        readOnly: this.readOnly,
      },
      mode: "simple", // or 'simple'
    };
  },
  computed: {
    richText: {
      get: function() {
        return this.html;
      },
      set: function(val) {
        this.$emit("update", val);
      },
    },
  },
  created() {},
  mounted() {},
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    onBlur() {
      console.log("richText", this.richText);
    },
    onChange(editor) {},
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<!-- <style src="@wangeditor/editor/dist/css/style.css"></style> -->
<style lang="scss" scoped>
/deep/ strong span {
  font-weight: bold;
}
</style>
